<template>
    <Layout :isLogin="true">
        <div slot="epassport">
            <iframe
                ref="iframe"
                :src="iframeUrl"
            ></iframe>
        </div>
    </Layout>
</template>

<script>
import { sdk } from 'data';
import { parseQuery } from '@mcfe/tools';
import { reportLx } from '@lsfe/tools';

const IFRAME_URL = sdk('SIGNUP');
export default {
    data() {
        return {
            IFRAME_URL,
            iframeUrl: `${IFRAME_URL}&feconfig=com.sankuai.malljiemo.vss`,
        };
    },
    created() {
        try {
            reportLx('pageView', {
                custom: {},
            }, null, 'c_chaoshi_bcudn35y');
        } catch {
            // pv埋点报错
        }
        const { ytType, hzType } = parseQuery();
        if (!ytType || !hzType) return;

        const sourceParams = {
            ytType: ytType || 10,
            hzType: hzType || 10,
        };
        // 邀请入驻会通过url访问该页面，需要将url中业态参数存入sessionStorage
        sessionStorage.setItem('sourceParams', JSON.stringify(sourceParams));
    },
};
</script>
